module.exports = __webpack_public_path__ + "media/3.9aba2447.mp3";